import { parseProjectCatalogMemoryEnabled } from "@shared/projectCatalogMemoryFlag";

export const projectCatalogMemoryEnabled = parseProjectCatalogMemoryEnabled(
  import.meta.env.VITE_PROJECT_CATALOG_MEMORY_ENABLED,
);
